import { useState } from 'react';
import useApp from '../AppContext';
import { ErrorAlert } from '../crud/utils';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './../Login.css';
import './../Sign Up/SignUp.css';
import { t } from './../i18n';
import { useNavigate } from "react-router-dom";
import { callApi } from '../crud/utils';

function SignUp() {
    const app = useApp();
    const [serverUrl] = useState(app.serverUrl);
    const navigate = useNavigate();
    const [loginName, setLoginName] = useState("");
    const [email, setEmail] = useState("");
    const [isBtnActiveFlg, setIsBtnActiveFlg] = useState(true);
    const [error, setError] = useState(null);
    const [phone, setPhone] = useState("");
    const [company, setCompany] = useState("");
    const language = localStorage.getItem('preferredLanguage') || app.sessionToken?.Language

    async function requestSignUp() {
        setIsBtnActiveFlg(false);

        if (!loginName.trim()) {
            setError(t('signUp.requiredName', language));
            setIsBtnActiveFlg(true);
            return;
        }

        if (!email.trim()) {
            setError(t('signUp.requiredEmail', language));
            setIsBtnActiveFlg(true);
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError(t('signUp.invalidEmail', language));
            setIsBtnActiveFlg(true);
            return;
        }

        if (!company.trim()) {
            setError(t('signUp.requiredCompany', language));
            setIsBtnActiveFlg(true);
            return;
        }
        setIsBtnActiveFlg(false);

        const bodyJson = {
            username: loginName,
            email: email,
            socialSecurityNo: company,
            phone: phone
        };



        try {
            // console.log("Requesting sign-up with body:", bodyJson);
            setError(null);

            const url = `${serverUrl}/api/createuser`;

            const result = await callApi("POST", url, '', bodyJson);
            // console.log("Sign-up success:", result);
            if (result?.success) {
                navigate('/');
            } else {
                setError(result?.message || t('signUp.error', language));
            }
        } catch (err) {
            setError(err.message || t('signUp.error', language));
        } finally {
            setIsBtnActiveFlg(true);
        }
    }

    function whenLoggedOff() {
        const parsedCustomStyle = app.sessionToken?.CustomStyle
            ? JSON.parse(app.sessionToken.CustomStyle)
            : {};

        const logoPath = parsedCustomStyle.Logo
            ? `${app.serverUrl}${parsedCustomStyle.Logo}`
            : 'images/Logo-Yard.png';
        return (
            <>
                <div className='container-for-all-login' style={{ color: app.theme === 'dark' ? 'white' : '#000' }}>
                    <img
                        style={{ height: "200px" }}
                        src={logoPath}
                        alt='Company-Logo'
                    />
                    <Form onSubmit={(e) => { e.preventDefault() }} style={{ background: app.theme === "dark" ? "#4e4e4eff" : "white" }}>
                        <h4>{t('signUp.title', language)}</h4>

                        <div className='container-signup-split-inputs'>
                            <Form.Group className="mb-2" controlId="formBasicEmail">
                                <Form.Label>{t('signUp.fullName', language)} <b>*</b></Form.Label>
                                <Form.Control
                                    onChange={(e) => setLoginName(e.target.value)}
                                    value={loginName}
                                    placeholder={t('signUp.fullName', language)}
                                />
                            </Form.Group>
                        </div>

                        <Form.Group className="mb-2">
                            <Form.Label>{t('signUp.email', language)} <b>*</b></Form.Label>
                            <Form.Control
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                                type="email"
                                placeholder={t('signUp.email', language)}
                            />
                        </Form.Group>



                        <div className='container-signup-split-inputs'>
                            <Form.Group className="mb-2" controlId="formBasic3PL">
                                <Form.Label>{t('signUp.company', language)} <b>*</b></Form.Label>
                                <Form.Control
                                    value={company}
                                    onChange={(e) => setCompany(e.target.value)}
                                    placeholder={t('signUp.company', language)}
                                />
                            </Form.Group>
                        </div>


                        <Form.Group className="mb-2" controlId="formBasicPhone">
                            <Form.Label>{t('signUp.phone', language)}</Form.Label>
                            <Form.Control
                                onChange={(e) => setPhone(e.target.value)}
                                value={phone}
                                placeholder={t('signUp.phone', language)}
                            />
                        </Form.Group>

                        <div className='container-signup-split-inputs mt-3'>
                            <Form.Group>
                                <Button onClick={() => navigate('/')} variant="secondary" className='secondary-btn-signup'>
                                    {t('common.backButton', language)}
                                </Button>
                            </Form.Group>
                            <Form.Group>
                                <Button onClick={requestSignUp} variant="primary" type="submit" className='primary-btn-signUp'>
                                    {t('common.submit', language)}
                                </Button>
                            </Form.Group>
                        </div>
                    </Form>
                </div>
                <img src={app.theme === "light" ? '/images/Entersoft-Logo-Login-light.png' : '/images/Entersoft-Logo-Login-dark.png'} alt='Logo-Entersoft' className='Entersoft-Logo-Login' />
                {logoPath !== 'images/Logo-Yard.png' && <img src={app.theme === "light" ? '/images/Aberon-Logo-Login-light.png' : '/images/Aberon-Logo-Login-dark.png'} alt='Logo-Aberon' className='Aberon-Logo-Login' />}
                {!isBtnActiveFlg && <div className='container-loading'><div className="loader"></div></div>}
            </>
        );
    }

    function createContent() {
        if (!app.user) {
            return whenLoggedOff();
        }
    }

    return (
        <div className="mt-4">
            <ErrorAlert message={error} setMessage={setError} language={language} />
            {createContent()}
        </div>
    );
}

export default SignUp;
